/**
 * Resume tools that work without signing in (see SecurityConfig public resume API).
 */
export function isPublicResumePathname(pathname) {
  if (!pathname || typeof pathname !== 'string') return false;
  // App root redirects to resume tools; allow guests through so they see contractor eval first.
  if (pathname === '/') return true;
  if (pathname === '/resume') return true;
  return (
    pathname.startsWith('/resume/contractor') || pathname.startsWith('/resume/jd-improve')
  );
}
